import React from 'react'
import { useTranslation } from 'react-i18next'
import InputWrapper from '../../Formik/InputWrapper'
import SettingsLabelText from '../../UI/SettingsLabelText'
import OrganizationCode from '../../UI/OrganizationCode'
import UpdateOrgName from '../../Forms/UpdateOrgName'
import UploadLogo from '../../Forms/UploadLogo'

const CompanyProfile = () => {
  const { t } = useTranslation()
  return (
    <div>
      <h2 className='font-bold text-2xl text-[#3D3D3D]'>
        {t('companyProfile')}
      </h2>

      <div className='flex flex-col gap-5 sm:gap-20 sm:flex-row mt-8'>
        <div className='sm:w-[50%] flex flex-col gap-5'>
          <InputWrapper>
            <SettingsLabelText text={t('updateCompanyName')} />
            <UpdateOrgName />
          </InputWrapper>

          <InputWrapper>
            <SettingsLabelText text={t('companyCodeLabel')} />
            <OrganizationCode />
          </InputWrapper>
        </div>

        <InputWrapper>
          <SettingsLabelText text={t('companyLogo')} />
          <UploadLogo />
        </InputWrapper>
      </div>
    </div>
  )
}

export default CompanyProfile
